// extracted by mini-css-extract-plugin
export default {"lifeZone":"index_lifeZone_yhI-u"};